import styled from "@emotion/styled"
import colors from "theme/colors"
import { NewText } from "ui"

const StyledDomainBox = styled.div`
  margin-top: 40px;
  ${(props) => props.theme.breakpoints.up("md")} {
    margin-top: 0px;
  }
`

const StyledTitleBox = styled.div`
  border-bottom: 1px solid;
  h3 {
    background: ${colors.black};
    display: inline;
    padding: 4px 16px 4px 16px;
  }
`

type ActivityDomainProps = {
  title: string
  text: string
}
function ActivityDomain({ title, text }: ActivityDomainProps) {
  return (
    <StyledDomainBox>
      <StyledTitleBox>
        <NewText
          component={"h3"}
          desktopFontSize={20}
          desktopLineHeight={"28px"}
          desktopFontWeight={500}
          mobileFontSize={20}
          mobileLineHeight={"28px"}
          color={colors.white}
          smallDesktopFontSize={14}
          smallDesktopLineHeight="20px"
        >
          {title}
        </NewText>
      </StyledTitleBox>
      <NewText
        component={"p"}
        desktopFontSize={16}
        desktopLineHeight={"24px"}
        desktopFontWeight={400}
        marginTop={"16px"}
        smallDesktopFontSize={12}
        smallDesktopLineHeight="18px"
      >
        {text}
      </NewText>
    </StyledDomainBox>
  )
}

export default ActivityDomain
